import TableWithTitle from 'common/components/organisms/TableWithTitle/TableWithTitle';
import styled, { css } from 'styled-components';

export const BenefitsPreferencesTable = styled(TableWithTitle)(
  () => css`
    max-width: 600px;
  `,
);
